var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", { staticClass: "nav-item" }, [
    _c(
      "a",
      {
        staticClass: "btn btn-success",
        class: { disabled: !_vm.canSendMessage },
        on: { click: _vm.sendQuickMessage },
      },
      [_vm._v("\n            NEW MESSAGE\n        ")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }